import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Text,
  Link,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

const FundInFocus: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={{ xs: '450px', sm: '300px' }}
      minH={{ xs: '450px', sm: '300px' }}
      maxH="450px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus: Multiple CVC funds backed Japanese VC Firm -{' '}
          <Link
            href="https://globalbrains.com/en"
            target="_blank"
            rel="noreferrer"
          >
            Global Brain
          </Link>
          , is bullish on investing in Indian start-ups.
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Anjani Bansal, Partner & India Country Head,{' '}
          <Link
            href="https://globalbrains.com/en"
            target="_blank"
            rel="noreferrer"
          >
            Global Brain
          </Link>
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our &apos;Fund in Focus&apos; series where we profile our
          member funds, underscore their investment philosophy, and highlight
          some of their interesting work. Today we speak to Anjani Bansal,
          Partner and India Country Head of the Japanese VC firm -{' '}
          <Link
            href="https://globalbrains.com/en"
            target="_blank"
            rel="noreferrer"
          >
            Global Brain
          </Link>
          . With him joining{' '}
          <Link
            href="https://globalbrains.com/en"
            target="_blank"
            rel="noreferrer"
          >
            Global Brain
          </Link>
          , the VC firm is all set to step up its operations in India. Bansal in
          the interaction throws light on{' '}
          <Link
            href="https://globalbrains.com/en"
            target="_blank"
            rel="noreferrer"
          >
            Global Brain
          </Link>{' '}
          being one of the few GPs that manage a pool of multiple funds of
          global corporates with specific investment strategies and the rising
          sentiment among CVCs towards Indian start-ups in recent times.
        </Text>
      </Box>

      <Img
        src="/webp/Anjani Bansal.webp"
        alt="Anjani Bansal"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="contain"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Anjani Bansal, Partner & India Country Head,{' '}
            <Link
              href="https://globalbrains.com/en"
              target="_blank"
              rel="noreferrer"
            >
              Global Brain
            </Link>
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="center">
              <Link
                href="https://www.linkedin.com/in/anjani-bansal-3444876/"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. How would you describe the investment philosophy of Global Brain?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            It is fairly straightforward - we invest in strong teams solving
            large problems with deep revenue pools yet to be unlocked. Over the
            last 25 years, we have developed muscle memory from successes and
            failures from investing across multiple sectors in SE Asia, North
            America, Europe and Japan. We try to understand the mental model of
            founders and their vision for the company. Combining that with their
            ability to execute, helps us estimate the probability of them
            turning a product in to a large company. We invest in Pre-Series A
            to Series B rounds.
            <br />
            <br />
            Furthermore, we assess our own ability to help the team. We have a
            deep network of Japanese corporates operating in global markets.
            This provides unique opportunities to startups for cross-border
            expansion and strategic partnerships with large multi-nationals. Our
            team of experienced operators and investors has a proven track
            record of nurturing innovative and ambitious companies. We look at
            each company to determine areas where we can provide meaningful
            support.
            <br />
            <br />
            The global context has become highly uncertain driven by risks from
            pandemic, climate change, geopolitics, inflation, etc. We believe
            that in such uncertain times lies the greatest opportunity, and that
            the power of startups is vital to overcome unprecedented situations.
            <br />
            <br />
            Partnerships with corporations is crucial for startups to achieve
            rapid growth. Coupling innovation led by startups with operational
            expertise and scale of corporations, is more likely to bring about
            large scale transformation. We leverage our deep network with global
            corporations to unlock such opportunities.
          </Text>
        </Box>
        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. Apart from your own fund, Global Brain also manages several
            corporate&apos;s investments into startups. This makes it a unique
            fund. We are keen to know how you liaison with these corporates.
            Which - sectors, stages, solutions, etc. - are they looking into for
            investments? What&apos;s their take on the new crop of Indian
            start-ups?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Globally, we are among very few GPs that manage a pool of multiple
              funds with specific investment strategies. We manage thirteen
              funds - our core sector agnostic fund, and twelve CVC funds backed
              by global corporates such as Mitsubishi, Sony, Mitsui, KDDI,
              Epson, etc. CVC funds have specific investment thesis based on
              strategic priorities that we have agreed on with each corporate.{' '}
              <br /> <br />
              Frequently, we pool monies from multiple funds into an investment
              depending on interest from the founders and funds&apos; investment
              thesis. For example, a fintech startup building wealth management
              products for Gen Z in India could have synergies with one of our
              CVC funds where the strategy includes building such products for
              markets in Southeast Asia or Japan. <br /> <br />
              Our CVC funds span multiple sectors such as financial services,
              telecom, infrastructure, electronics, agritech, food and
              healthcare. We invest across Series A-C and have higher threshold
              for investment duration from these funds. <br /> <br />
              Overall, the sentiment of CVCs towards Indian startups is very
              bullish. There is strong appreciation of high quality of Indian
              founders who are building for the world&apos;s fastest growing
              large economy. The conviction is further strengthened by growing
              exit opportunities through M&A and IPOs in India.
            </Text>
          </Box>
        </Box>

        {/* Question 3 */}

        <Box py="16px">
          <Heading variant="blogQuestion" pt="28px">
            3. How do you identify your &apos;winning&apos; start-ups? With
            Global Brain&apos;s India office being set up in Bengaluru recently,
            which kind of sectors, innovation or products which will interest
            you to invest in?
          </Heading>
          <Box pt="16px">
            <Text variant="blogAnswer" pb="8px">
              While we are a global fund, India is clearly the top priority
              region for us going forward. We believe there is strong growth
              potential in the economy, and that affluence of its large
              population with continue to increase. This will unlock large
              demand for products and services, and use of technology will be
              the most important lever to serve this market. India has a lot
              going for the country:
            </Text>
            <UnorderedList>
              <ListItem pb="14px">
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Growing startup ecosystem:
                </Text>
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Already global #4 VC market by size (~$15B)
                </Text>
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Global #3 in number of Unicorns (~85 in 2022)
                </Text>
              </ListItem>
              {/* 2nditem */}
              <ListItem pb="14px">
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Large working population:
                </Text>
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  The largest population (~1.4B) in the world
                </Text>
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Median age is 28.7 years, compared to 48.6 for Japan
                </Text>
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  India will be the world&apos;s future talent factory as it
                  will have 20% of the globe&apos;s working population by 2047
                </Text>
              </ListItem>
              {/* 3rditem */}
              <ListItem pb="14px">
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Country leapfrogging with digital:
                </Text>
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Already one of the largest and fastest-growing markets for
                  digital consumers ( 850M internet users)
                </Text>
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Smartphone penetration is still ~45%. Next billion will be
                  “digitized” in coming years
                </Text>
              </ListItem>
              {/* 4thitem */}
              <ListItem pb="14px">
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Growing M&A and IPO market:
                </Text>
                <Text variant="blogAnswer" pl={{ md: '12px', lg: '18px' }}>
                  Successful startups are buying other startups, and traditional
                  large companies are buying new age startups
                </Text>
              </ListItem>
            </UnorderedList>
            <Text variant="blogAnswer" mt="12px">
              We are particularly excited about certain broad themes. Markets of
              Tier II+ India is primed for growth in both existing and new
              products and services. We like founders who are building for this
              large segment. This could include building blocks such as
              connectivity, social networks, supply chain and marketplaces.
              Product development, Distribution and Customer Acquisition require
              a differentiated approach in these markets. <br />
              <br />
              Wealth Management, Insurance and Lending for specific customer
              segments such as Gen Z, Middle income segment and MSMEs are
              exciting. Modernization of agriculture in India through
              technologies such as remote sensing and drones, and scaling up of
              export markets in high value commodities is another great
              opportunity. Noncommunicable diseases, Primary health care, and
              Diagnostics in regions not served by large hospital chains present
              important problems that can be solved for big markets. <br />
              <br />
              We are also bullish on certain emerging areas in India such as
              Space and Lifesciences. Climate tech is an important part of our
              global portfolio and we are keen to identify next set of
              investments from India. India plays a critical role in solving the
              challenge of climate change globally, and we hope to support
              Indian entrepreneurs taking on this problem.
            </Text>
          </Box>
        </Box>

        {/* Question 4 */}
        <Flex py="16px">
          <Box>
            <Heading variant="blogQuestion" pt="16px">
              4. This year completes 25 years for Global Brain. How would you
              describe the transformation of investment landscape over the years
              while throwing light on the European, the Indian subcontinent and
              the Southeast Asia regions?
            </Heading>
            <Box>
              <Text variant="blogAnswer" py="16px">
                Over the last two and a half decades, we have experienced a
                number of crises including the dot-com bubble and the global
                financial crisis. But with each crisis, great startups have
                emerged and created new opportunities. We are entering a
                difficult period in the investment environment, but historically
                speaking, our global presence and experience tells us that this
                is a great opportunity. <br />
                <br />
                We have 10 offices in 9 countries, and our strength is our
                ability to formulate strategies flexibly based on insights drawn
                from each region. We prioritize investment areas and regions
                based on our continuous assessment of markets and underlying
                opportunities. Startups building in certain areas that will
                shape our collective future, such as Life Sciences, Healthcare
                Devices and Climate Tech, are particularly exciting to us.{' '}
                <br />
                <br />
                Same applies to our fund management strategy. We pursue
                diversity in funds that we manage, such as sector agnostic funds
                dedicated to certain regions or stage, and CVC funds backed by
                global corporates with strategic priorities. India is clearly
                our top priority region.
              </Text>
            </Box>
          </Box>
        </Flex>

        {/* Question 5 */}
        <Flex pt="8" pb="20px" gap="1rem">
          <Box>
            <Heading variant="blogQuestion" pb="20px" pt="12px">
              5. Any investments made so far in India? Tell us about the
              exciting work done by some of your portfolio companies here in
              India.
            </Heading>

            <Text variant="blogAnswer" pt="8px">
              We have invested in multiple sectors in India. It&apos;s a very
              exciting portfolio and foundation of our growth in India. Some of
              our investments include:
              <br />
              <br /> <b> Bugworks</b> is one of our early investments in India.
              It has developed novel therapeutics for the treatment of
              antibiotic-resistant bacterial infections. It has created a
              platform, ELUDE, to discover novel antibiotics. ELUDE mitigates
              efflux-mediated drug resistance which is a critical barrier in
              Gram negative bacteria. Bacterial infections are becoming
              resistant to antibiotics, posing a fast-growing public health
              threat worldwide, leading to increased mortality and morbidity,
              longer hospital stays, and increased health care costs. <br />
              <br />
              <b> Near</b> provides solutions for businesses to better
              understand consumer behavior and unlock potential for growth
              strategies. Near&apos;s data intelligence solutions serve both
              operational and marketing data leaders, whether they are shopping,
              traveling, dining, tourism or product purchases. Nearvs Data
              universe data universe curates one of the world&apos;s largest
              sources of information about people, places and products,
              comprising 1.6 billion unique user identities in over 70 million
              locations in 44 countries. With strategic and exclusive data sets
              and customer partnerships, Near aggregates multiple data sources
              across data types and uses deep learning to better understand
              consumer behavior. , leveraging the company&apos;s AI-driven
              model. <br />
              <br />
              <b> ByteBeam</b> is developing a backend platform as a service
              that radically reduces cost and time to production for a wide
              range of IoT devices across industries. It provides a rich suite
              of infrastructure services which enables OEMs to focus on rolling
              out better IoT products at a much faster pace. These services
              include synchronising data across devices and mobile app,
              visualizing analytics and insights to optimize performance,
              remotely diagnosing device failures and rolling out bug fixes and
              over the air updates. The platform has security and privacy
              features such as device level data encryption and role based
              access.
              <br />
              <br />
              <b> Airmeet</b> has built an immersive engagement suite that
              empowers businesses and communities to connect with their
              audience, engage in meaningful conversations, exchange feedback,
              and build long-lasting relationshipsthrough events. Airmeet&apos;s
              360-degree attendee engagement suite helps to dive deep into
              audience needs and dynamically update customer engagement strategy
              with highly interactive touchpoints. It&apos;s functionality,
              customization and data security are best in the market. <br />
              <br />
              <b> Lokal</b> is a digital platform providing hyperlocal services
              in vernacular languages that are tailored for population in tier
              II+ cities and towns in India. It offers unique content-led
              digital marketing solutions for various SMEs and brands targeting
              tier II and III towns in India. As smartphone and internet use
              continues to grow, Lokal is building for the underserved market
              that requires a more differentiated approach as compared to metros
              of India.
            </Text>
          </Box>
          <Img
            mt="20px"
            src="/webp/Infographic_Global Brain.webp"
            alt="Infographic_Global Brain.webp"
            w="43%"
            objectFit="contain"
            display={{ xs: 'none', sm: 'block' }}
          />
        </Flex>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default FundInFocus;
